// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export { XhrHttpsClient as DefaultHttpsClient } from "./xhrHttpsClient";
